import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Icon, Row } from 'antd'

class InfoText extends Component {
  render() {
    const { text, noMarginTop } = this.props
    return (
      <Row style={{ fontSize: '10pt', marginTop: noMarginTop ? 0 : 10 }}>
        <Icon type="info-circle" style={{ marginRight: '10px' }} />
        <span>{text}</span>
      </Row>
    )
  }
}

InfoText.propTypes = {
  text: PropTypes.string.isRequired,
}
InfoText.defaultProps = { text: '' }

export default InfoText
